import React from "react";
import { Link } from "react-router-dom";
import { ClipboardList, PhoneCall, Truck, ShieldCheck } from "lucide-react";

const STEPS = [
  { n: "01", icon: ClipboardList, t: "Send photos or call us", d: "Snap a few photos of the items or pile, or call us directly. Takes about a minute." },
  { n: "02", icon: PhoneCall, t: "Get a quick quote", d: "We review your photos and details and send back a firm starting price the same day." },
  { n: "03", icon: Truck, t: "We match your job with a crew", d: "We coordinate pickups with local hauling crews based on your location, load size, and availability." },
  { n: "04", icon: ShieldCheck, t: "Junk removed · you confirm", d: "The crew hauls everything away and disposes of it properly. You confirm completion — that's it." },
];

const HowItWorks = () => (
  <div data-testid="how-page">
    <section className="border-b border-border bg-muted">
      <div className="container-wide py-16 lg:py-20">
        <p className="kicker">How it works</p>
        <h1 className="mt-3 font-display text-4xl font-black sm:text-5xl lg:text-6xl">
          Request. Schedule. Done.
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
          Getting rid of junk should be simple. Here&apos;s exactly what happens after you hit &quot;Get a Free
          Quote.&quot;
        </p>
      </div>
    </section>

    <section className="section">
      <div className="container-wide">
        <div className="grid gap-6 md:grid-cols-2">
          {STEPS.map((s) => (
            <div key={s.n} className="border-l-4 border-primary bg-card p-8" data-testid={`how-step-${s.n}`}>
              <div className="flex items-center gap-4">
                <span className="font-display text-4xl font-black text-primary">{s.n}</span>
                <s.icon className="h-6 w-6 text-secondary" />
              </div>
              <h3 className="mt-4 font-display text-2xl font-bold">{s.t}</h3>
              <p className="mt-3 text-muted-foreground">{s.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 rounded-sm border border-border bg-[hsl(145,27%,24%)] p-10 text-white">
          <p className="kicker text-primary">Why homeowners choose us</p>
          <h2 className="mt-3 font-display text-3xl font-black sm:text-4xl">
            No games. No hidden fees. Just hauling done right.
          </h2>
          <p className="mt-4 max-w-2xl text-white/80">
            We work hard so you don&apos;t have to. One call, one price, one crew — and the junk is gone.
          </p>
          <Link to="/contact" className="btn-cta mt-6" data-testid="how-cta">
            Request Pickup
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default HowItWorks;
